import {NaniumObject, RequestType, Type} from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import {Gathering} from "../../entities/gathering.entity";
import {GeoLocationType} from "../../entities/types/geoLocation.type";

export class GatheringQueryPaginatedRequestBody extends NaniumObject<GatheringQueryPaginatedRequestBody> {
	@Type(Number) page: number;
	@Type(Number) pageSize: number;
	@Type(Object) filter?: any;
	@Type(Object) sorting?: any;
	@Type(Boolean) includeAnalytics?: boolean;
	/**
	 * Optional user location used to break ties / re-order results by
	 * distance to the user. When omitted the executor falls back to its
	 * default sort (`startingAt: 1`).
	 *
	 * Gatherings don't carry a coordinate of their own — we look up
	 * each gathering's owning facility and use that location.
	 */
	@Type(GeoLocationType) userLocation?: GeoLocationType;
}

export class GatheringQueryPaginatedResponse extends NaniumObject<GatheringQueryPaginatedResponse> {
	@Type(Array, Gathering) gatherings: Gathering[];
	@Type(Number) totalCount: number;
	@Type(Number) pageCount: number;
	@Type(Number) pageSize: number;
	@Type(Number) currentPage: number;
}

@RequestType({
	responseType: GatheringQueryPaginatedResponse,
	genericTypes: { TRequestBody: GatheringQueryPaginatedRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class GatheringQueryPaginatedRequest extends ServiceRequestBase<GatheringQueryPaginatedRequestBody, GatheringQueryPaginatedResponse> {
	static serviceName: string = 'NaniumDemo:gathering/queryPaginated';
}
